export const LABELS = {
  archiveLabel: 'Archive Label',
  archiveButtonText: 'Archive',
  archiveLabelError: 'There was an error archiving the label. Please try again.',
  archiveDialogBody: (labelName: string) =>
    `Archiving hides "${labelName}" so it can't be added to issues or pull requests. It remains on anything that already uses it, and you can unarchive it any time.`,
  archiveConfirmDescription:
    'Archiving a label will remove it from all issues and pull requests. You can restore it later from the archived labels list.',
  cancelButtonText: 'Cancel',
  clearSearch: 'Clear search',
  color: 'Color',
  createButtonText: 'Create label',
  deleteButtonText: 'Delete',
  deleteLabelAssociatedIssuesNote: 'Deleting this label will remove it from all issues and pull requests.',
  deleteLabelButtonText: 'Delete this label',
  deleteLabelError: 'There was an error deleting the label. Please try again.',
  deleteLabelWarningPermanent: 'Once you delete this label, you will not be able to see it again.',
  description: 'Description',
  editLabel: 'Edit label',
  editLabelError: 'Could not update label',
  invalidColor: 'Color is invalid',
  labelCreateError: 'Could not create label',
  labelCreatePermissionError: 'You do not have permission to create labels in this repository',
  labelDeleteDialogTitle: 'Permanently delete label',
  labelDescriptionPlaceholder: 'Optionally add a description',
  labelNamePlaceholder: 'Label name',
  labelPreview: 'Label preview',
  name: 'Name',
  nameRequired: 'Name is required',
  newLabel: 'New label',
  noArchivedLabelsDescription: 'Labels you archive will appear here.',
  noArchivedLabelsTitle: 'There are no archived labels in this repository',
  noLabelsCreatedDescription: 'Start creating labels using the "New Label" button.',
  noLabelsCreatedTitle: 'There are no labels in this repository',
  noMatchingLabelsDescription: 'We couldn’t find any labels that match your filter. Please try again.',
  noMatchingLabelsTitle: 'No matching labels',
  saveChanges: 'Save changes',
  search: 'Search',
  searchAll: 'Search all labels',
  unarchiveButtonText: 'Restore',
  unarchiveLabelError: 'There was an error removing the label from the archive. Please try again.',
  updateLabelError: 'There was an error updating this label',
}
